<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="menu.inventoryStateConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(type)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="200"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="inventoryState" title="business.label.inventoryState" width="80"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="defaults" title="business.label.defaults" width="60"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:warehouses}" field="warehouse.id" title="business.label.warehouse"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:owners}" field="owner.id" title="business.label.owner"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <inventory-state-config-editor ref="editor" :inventory-states="inventoryStates" :owners="owners" :warehouses="warehouses" @success="refresh(type)"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { OrderType } from '@/api/dto/common/OrderType'
import InventoryStateConfigEditor from '@/views/basedata/orderType/InventoryStateConfigEditor.vue'

export default {
  name: 'InventoryStateConfig',
  components: { InventoryStateConfigEditor },
  props: {
    inventoryStates: { type: Array, default: () => [] },
    warehouses: { type: Array, default: () => [] },
    owners: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      type: new OrderType(),
      list: []
    }
  },
  methods: {
    refresh(type) {
      this.type = type
      if (this.type.isNew()) {
        return this.$message.warning('请先选择订单类型')
      }
      this.loading = true
      findAll('inventoryStateConfigFactory', { 'orderType.id': this.type.id }).then(res => {
        if (res.success) {
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.$refs.editor.add(this.type)
    },
    edit(row, copy) {
      this.$refs.editor.edit(row.id, copy)
    }
  }
}
</script>